<template>
  <input
    :id="id"
    :name="name"
    :value="value"
    type="hidden">
</template>

<script>
import UIComponentMixin from '../../Mixins/UIComponentMixin';

export default {
  name: 'HiddenInput',

  mixins: [
    UIComponentMixin
  ],

  props: ['value', 'name']
};
</script>
